export default __webpack_public_path__ + "static/media/130.855974e4.png";